import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { postApi } from "../../services/api/api";
import "./ManagementTeam.css";

const ManagementTeam = () => {
  const [managements, setManagements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  // Pagination & Search States
  const [skip, setSkip] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const TAKE = 25;

  // Show/Hide Social Links State (stores { [memberId]: boolean })
  const [expandedSocials, setExpandedSocials] = useState({});

  // Fetch Team Data
  const fetchManagementsList = async (currentSkip) => {
    if (loading) return;
    setLoading(true);
    try {
      const response = await postApi("/team-list", {
        skip: currentSkip,
        take: TAKE,
        search: ""
      });

      const managementDataArray = response?.data;

      if (Array.isArray(managementDataArray)) {
        // If fetched data is less than TAKE, we've hit the end of the list
        if (managementDataArray.length < TAKE) {
          setHasMore(false);
        }

        // Append new data to existing list
        setManagements((prev) =>
            currentSkip === 0 ? managementDataArray : [...prev, ...managementDataArray]
        );
      } else {
        console.error("API response format unexpected:", response);
        if (currentSkip === 0) setManagements([]);
        setHasMore(false);
      }
    } catch (err) {
      console.error("Error fetching live managements:", err);
      setError(err.message || "Failed to load managements. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // Trigger fetch when skip count updates
  useEffect(() => {
    fetchManagementsList(skip);
  }, [skip]);

  // Infinite Scroll Listener
  useEffect(() => {
    const handleScroll = () => {
      if (
          window.innerHeight + document.documentElement.scrollTop >=
          document.documentElement.offsetHeight - 300 // Triggers 100px before reaching absolute bottom
      ) {
        if (hasMore && !loading) {
          setSkip((prevSkip) => prevSkip + TAKE);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, loading]);

  // Toggle Social Visibility
  const toggleSocials = (id) => {
    setExpandedSocials((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
      <>
        <main className="main_wrapper">
          <div className="inn-ban">
            <div className="container">
              <div className="row">
                <h1>Management Committee</h1>
                <p>Vikas Mandal Mulund - Management Committee 2025-28</p>
              </div>
            </div>
          </div>

          <section className="management_team">
            <div className="container">
              <div className="row justify-content-center">
                {managements.map((member, index) => {
                  // Fallback to index if API item doesn't provide a unique ID
                  const memberId = member.id || index;
                  const isSocialVisible = !!expandedSocials[memberId];

                  return (
                      <div className="col-md-3" key={memberId}>
                        <div className="ab-team" onClick={() => setSelectedImage(member.image_url)} 
                            style={{ cursor: "pointer" }}>
                          <img
                            src={member.image_url}
                            alt={member.name}
                            loading="lazy"
                          />
                          <h4>{member.name}</h4>
                          <p>{member.designation}</p>

                          {/* Toggle Button */}
                          {/* <button
                              className="btn btn-sm btn-light my-2"
                              onClick={() => toggleSocials(memberId)}
                              style={{ fontSize: '0.8rem', border: '1px solid #ccc' }}
                          >
                            {isSocialVisible ? "Hide Socials" : "Show Socials"}
                          </button> */}

                          {/* Conditionally Rendered Social Links */}
                          {/* {isSocialVisible && (
                              <ul className="social-light">
                                <li>
                                  <a href={member.facebook || "#!"} target="_blank" rel="noreferrer">
                                    <i className="fa-brands fa-facebook-f"></i>
                                  </a>
                                </li>
                                <li>
                                  <a href={member.whatsapp || "#!"} target="_blank" rel="noreferrer">
                                    <i className="fa-brands fa-whatsapp"></i>
                                  </a>
                                </li>
                                <li>
                                  <a href={member.twitter || member.x || "#!"} target="_blank" rel="noreferrer">
                                    <i className="fa-brands fa-x-twitter"></i>
                                  </a>
                                </li>
                                <li>
                                  <a href={member.instagram || "#!"} target="_blank" rel="noreferrer">
                                    <i className="fa-brands fa-instagram"></i>
                                  </a>
                                </li>
                              </ul>
                          )} */}
                        </div>
                      </div>
                  );
                })}
              </div>

              {/* Status Indicators */}
              {loading && (
                  <div className="text-center my-4">
                    <p>Loading more team members...</p>
                  </div>
              )}
              {error && (
                  <div className="text-center text-danger my-4">
                    <p>{error}</p>
                  </div>
              )}
              {/*{!hasMore && managements.length > 0 && (
                  <div className="text-center my-4 text-muted">
                    <p>You've reached the end of the management team list.</p>
                  </div>
              )}*/}
            </div>
          </section>
          {/* Lightbox Popover Viewport Modal */}
          {selectedImage && (
            <div
              className="image_modal"
              onClick={() => setSelectedImage(null)}
            >
              <div
                className="modal_content"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={selectedImage}
                  alt="Management Member"
                  className="lightbox_image"
                />
              </div>
              <button
                  className="close_btn"
                  onClick={() => setSelectedImage(null)}
                >
                  ✕
                </button>
            </div>
          )}
        </main>
      </>
  );
};

export default ManagementTeam;